import React from 'react';
import classnames from 'classnames';
import refreshGoogleAds from '@gumtree/third-party-ads/src/refresh-google-ads';
import AdSlot from '@gumtree/third-party-ads/src/components/ad-slot';
import { DisplayAdSlotDivNames } from '@gumtree/third-party-ads/src/framework/dfp/ad-config/slot-configs';
import type { SlotName } from '@gumtree/third-party-ads/src/framework/dfp/ad-config/slot-configs';
import Carousel, { Props as CarouselProps } from '@gumtree/ui-library/src/carousel/carousel';
import Dialog from '@gumtree/ui-library/src/dialog/dialog';
import { ImageSlide, SliderProps, VideoSlide } from '@gumtree/ui-library/src/carousel/slider';

import './index.scss';

interface GalleryDialogProps {
    mediaLinks: (ImageSlide | VideoSlide)[];
    isOpen: boolean;
    onClose: () => void;
    slideNumber?: number;
    imageAltTitle?: string;
    hasControls?: boolean;
    hasIcon?: boolean;
    hasCounter?: boolean;
    endTracking?: CarouselProps['endTracking'];
    trackingContext?: CarouselProps['trackingContext'];
    // isShowGalleryBanner?: boolean;
}

export const extendSlidesWithAd = (
    slides: SliderProps['slides'],
    setIsShowGalleryBanner: React.Dispatch<boolean>
): SliderProps['slides'] => {
    if (slides.length >= 1) {
        const firstFewSlides = slides.slice(0, -1);
        const lastSlide = slides[slides.length - 1];
        const isSingleSlide = slides.length === 1;

        if (isSingleSlide) {

            lastSlide.onArrivalFromRight = () => {
                setIsShowGalleryBanner(true);
            };
        } else {
            lastSlide.onArrivalFromLeft = () => {
                // @ts-ignore
                refreshGoogleAds(window as WindowWithGoogleTag, [DisplayAdSlotDivNames.galleryMPU]);
            };
        }

        lastSlide.onArrivalFromRight = () => {
            setIsShowGalleryBanner(true);
        };

        return [
            ...firstFewSlides,
            lastSlide,
            {
                type: 'display-ad',
                slotId: DisplayAdSlotDivNames.galleryMPU as SlotName,
                onArrivalFromLeft: () => {
                    setIsShowGalleryBanner(false);
                    // @ts-ignore
                    refreshGoogleAds(window as WindowWithGoogleTag, [
                        DisplayAdSlotDivNames.galleryMPU,
                    ]);
                },
                invisibleToSlideCounter: true,
            },
        ];
    } else {
        return slides;
    }
};

const GalleryDialog: React.FC<GalleryDialogProps> = ({
    mediaLinks,
    isOpen,
    onClose,
    slideNumber,
    imageAltTitle,
    hasControls,
    hasIcon,
    hasCounter,
    endTracking,
    trackingContext,
    // isShowGalleryBanner,
}) => {
    const [isShowGalleryBanner, setIsShowGalleryBanner] = React.useState(true);
    const slidesWithAd = extendSlidesWithAd(mediaLinks, setIsShowGalleryBanner);

    if (!isOpen) {
        return null;
    }

    return (
        <div
            className={`image-carousel carousel ${classnames('cms-carousel')}`}
            data-q="image-carousel"
            data-testid="image-carousel"
        >
            <Dialog isOpen={isOpen} onClose={onClose}>
                <Carousel
                    slides={slidesWithAd}
                    itemsToShow={1}
                    slideNumber={slideNumber}
                    imageAltTitle={imageAltTitle}
                    hasControls={hasControls}
                    hasIcon={hasIcon}
                    hasCounter={hasCounter}
                    endTracking={endTracking}
                    trackingContext={trackingContext}
                />
                <aside style={isShowGalleryBanner ? {} : { display: 'none' }}>
                    <AdSlot id={DisplayAdSlotDivNames.galleryBanner} />
                </aside>
            </Dialog>
        </div>
    );
};

export default GalleryDialog;
